/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPublicContactAliases} from '../api'

 export const useQueryGetPublicContactAliases = createReactQueryHook('getPublicContactAliases', getPublicContactAliases)
